import { getSubdomain, fetchWithAuth } from '../helpers';
import { API_PASSWORD } from '../config';

export const changeOrderItemStatus = async (itemId) => {
  const apiPassword = "Project102$_";
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");

  // لا ترسل أي شيء سوى التوكن و api_password
  const apiUrl = `https://${subdomain}.restocash.app/api/change/order/items/status/${itemId}?api_password=${apiPassword}`;

  try {
    console.log("📡 تغيير حالة عنصر الطلب عبر:", apiUrl);

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل تغيير الحالة:", data);
      throw new Error(data?.message || "فشل في تغيير حالة العنصر.");
    }

    console.log("✅ تم تغيير الحالة بنجاح:", data);
    return data;
  } catch (error) {
    console.error("🔥 خطأ في تغيير الحالة:", error);
    throw error;
  }
};

// جلب بيانات شاشة التجهيز (المطبخ) مع دعم التوكن وكلمة السر في الرابط
export const getKitchenItemsWithPassword = async () => {
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const apiPassword = "Project102$_";

  const apiUrl = `https://${subdomain}.restocash.app/api/kitchen/items?api_password=${apiPassword}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data?.message || data?.error || "فشل في تحميل بيانات شاشة التجهيز.");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("🔥 خطأ أثناء الاتصال بسيرفر شاشة التجهيز:", error);
    throw error;
  }
};


